export const INIT_ESTAB = "INIT_ESTAB";
export const INIT_LANGUAGES = "INIT_LANGUAGES";
export const INIT_COUNTRIES = "INIT_COUNTRIES";
export const INIT_IDENTITY_DOCUMENTS = "INIT_IDENTITY_DOCUMENTS";
export const INIT_TRANSLATIONS = "INIT_TRANSLATIONS";
export const INIT_USER = "INIT_USER";
export const INIT_USER_ACTION_TYPES = "INIT_USER_ACTION_TYPES";
export const INIT_USER_ACTIONS = "INIT_USER_ACTIONS";
export const INIT_LEGAL_INFO = "INIT_LEGAL_INFO";
export const SET_HEADERS = "SET_HEADERS";
export const SET_USER = "SET_USER";
export const SET_USER_ACTIONS = "SET_USER_ACTIONS";
export const INIT_MESSAGES = "INIT_MESSAGES";
export const INIT_HASMDP = "INIT_HASMDP";
export const INIT_AUTHSTATUS = "INIT_AUTHSTATUS";
export const INIT_DISPLAY_CONTROL = "INIT_DISPLAY_CONTROL";
export const INIT_ESTAB_COLLECTION = "INIT_ESTAB_COLLECTION";
export const INIT_BY_ORGA = "INIT_BY_ORGA";
export const INIT_ETAB_REF = "INIT_ETAB_REF";
export const INIT_MOT_CHAMBRE = "INIT_MOT_CHAMBRE";
export const INIT_FIELD_RESIDENT_PARAM = "INIT_FIELD_RESIDENT_PARAM";